import styled from "styled-components";
import Alert, { AlertVariant } from "src/components/Alert";

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

export enum FormGlobalMessageVariant {
  success = "success",
  error = "error",
  warning = "warning",
}

type Props = {
  summary?: string;
  description?: string;
  variant: FormGlobalMessageVariant;
};

/**
 * Component for displaying a success or error message relating to a form submission.
 * This is for global errors, i.e. not form field errors.
 */
const FormGlobalSuccessErrorMessage = ({
  summary,
  description,
  variant,
}: Props) => {
  let alertVariant;
  switch (variant) {
    case FormGlobalMessageVariant.error:
      alertVariant = AlertVariant.error;
      break;
    case FormGlobalMessageVariant.success:
      alertVariant = AlertVariant.success;
      break;
    case FormGlobalMessageVariant.warning:
      alertVariant = AlertVariant.warning;
      break;
  }

  return (
    <Wrapper>
      <Alert
        variant={alertVariant as AlertVariant}
        summary={summary || ""}
        description={description}
      />
    </Wrapper>
  );
};

export default FormGlobalSuccessErrorMessage;
